import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Box, Button, Checkbox, Grid, Image, Modal, Typography, TextField } from '@iho-design-system/Loader';

/*
    - svg
*/
import EmptySVG from '../../../assets/images/icons/empty.svg';
import AlertWarning from '../../../assets/images/icons/alert-warning.svg';
import ArrowUpSVG from '../../../assets/images/icons/arrow-up.svg';
import ArrowDownSVG from '../../../assets/images/icons/arrow-down.svg';
import ChevronDownBlue from '../../../assets/images/icons/chevron-down-blue.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import editCreditSettlementAPI from '../../../api/edit/CreaditSettlement';

const List = ({ props, alertProps, insufficientStatusProps, reloadFinanceProps }) => {

    /*
       - defaultData
    */
    const [creditPayments, setCreditPayments] = React.useState('loading');
    const [balance, setBalance] = React.useState(0);
    const [selectedCreditPayment, setSelectedCreditPayment] = React.useState({});
    const [settlementAmount, setSettlementAmount] = React.useState(0);
    const [insufficientStatus, setInsufficientStatus] = React.useState(false);
    const [insufficientAmount, setInsufficientAmount] = React.useState(0);
    const [credit, setCredit] = React.useState('1,000,000');

    React.useEffect(() => {
        if (props.creditPayments !== '') {
            if (props.creditPayments.status === 200 && props.creditPayments.data.length > 0) {
                setCreditPayments(props.creditPayments.data);
            } else {
                setCreditPayments('empty');
            }
        }
        if (props.balance.status === 200) {
            setBalance(props.balance.data);
        }
    }, [props]);

    /*
        - chargeWallet
    */
    const chargeWallet = () => {
        if (credit.replaceAll(',', '') > 4999) {
            window.location.replace(`/api/mvc/payment/Wallet/GotoParsianIPG/1/${insufficientAmount}`);
        }
    }

    /*
        - selectedSelectedCreditPayment
    */
    const selectedSelectedCreditPayment = (obj, status) => {
        setSelectedCreditPayment(prev => ({ ...prev, [obj.Id]: `${status},${obj.Price}` }));
    }

    React.useEffect(() => {
        let keys = Object.keys(selectedCreditPayment);
        keys.forEach((obj) => {
            if (selectedCreditPayment[obj].split(',')[0] === 'true') {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--blue-ultra-light)';
            } else {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--white)';
            }
        });
    }, [selectedCreditPayment]);

    /*
        - creditSettlement
    */
    const creditSettlement = async () => {
        closeModal('confirmCreditSettlementModal');
        let keys = Object.keys(selectedCreditPayment);
        let selectedCreditPaymentId = [];
        let sum = 0;
        keys.forEach((obj) => {
            if (selectedCreditPayment[obj].split(',')[0] === 'true') {
                selectedCreditPaymentId.push(obj);
                sum = sum + +selectedCreditPayment[obj].split(',')[1];
            }
        });
        if (sum > balance.wallet.walletBalance) {
            setInsufficientStatus(true);
            insufficientStatusProps(true);
            setInsufficientAmount(sum - balance.wallet.walletBalance);
            return false;
        } else {
            setInsufficientStatus(false);
            insufficientStatusProps(false);
            setInsufficientAmount(0);
        }
        let parameters = selectedCreditPaymentId;
        let result = await editCreditSettlementAPI(parameters);
        if (result === 'success') {
            alertProps(['success', 'با موفقیت انجام شد']);
            reloadFinanceProps(Math.floor(Math.random() * 100));
            setSelectedCreditPayment({});
        } else {
            alertProps(['danger', 'خطایی رخ داده است']);
        }
        document.querySelectorAll('input[type=checkbox]').forEach((obj) => {
            obj.checked = false;
        });
    }

    /*
        - toggleDetail
    */
    const toggleDetail = (index) => {
        document.querySelector(`.detail${index}`).classList.toggle('d-none')
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        if (modal === 'confirmCreditSettlementModal') {
            let keys = Object.keys(selectedCreditPayment);
            let selectedCreditPaymentId = [];
            let sum = 0;
            keys.forEach((obj) => {
                if (selectedCreditPayment[obj].split(',')[0] === 'true') {
                    selectedCreditPaymentId.push(obj);
                    sum = sum + +selectedCreditPayment[obj].split(',')[1];
                }
                setSettlementAmount(sum);
            });
            if (sum > 0) {
                document.querySelector(`.${modal}`).classList.remove('d-none');
            }
        } else {
            document.querySelector(`.${modal}`).classList.remove('d-none');
        }
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    if (creditPayments === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (creditPayments === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block my-md text-center`}
                        component='h2'>
                        گزارشات مالی شما خالی است :(
                    </Typography>
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ گزارشی ثبت نشده است!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (creditPayments !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        {insufficientStatus === true &&
                            <Grid.Item
                                size='col-12 lg-8'>
                                <Box
                                    className={`d-inline-block p-lg border-solid border-warning rounded-sm`}
                                    ms={{
                                        backgroundColor: 'var(--orange-ultra-light)'
                                    }}>
                                    <Box>
                                        <Typography
                                            className={`d-flex text-bold`}>
                                            <Image
                                                src={AlertWarning}
                                                ms={{
                                                    width: '20px',
                                                    height: '20px'
                                                }} />
                                            توجه
                                        </Typography>
                                        <Typography
                                            className={`d-block`}>
                                            موجودی کیف پول شما برای مبالغ انتخاب شده کافی کافی نیست، کیف پول خود را شارژ نمایید.
                                        </Typography>
                                        <Typography
                                            onClick={() => openModal('increaseWalletModal')}
                                            className={`m-xs p-xs border-solid border-primary rounded-sm pointer`}
                                            ms={{
                                                backgroundColor: 'var(--white)'
                                            }}>
                                            شارژ کیف پول
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid.Item>
                        }
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:768px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '768px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                ردیف
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                شماره رزرو
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                مبلغ (تومان)
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                تاریخ ثبت رزرو
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {creditPayments.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`list${obj.Id} d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            className={`d-inline-block`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            <Checkbox
                                                                onChange={(status) => selectedSelectedCreditPayment(obj, status)}
                                                                label={index + 1}
                                                                ms={{
                                                                    verticalAlign: 'middle'
                                                                }} />
                                                        </Box>
                                                        <Box
                                                            className={`d-inline-block`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            {obj.Id}
                                                        </Box>
                                                        <Box
                                                            className={`d-inline-block`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            {(obj.Price / 10).toLocaleString()}
                                                        </Box>
                                                        <Box
                                                            className={`d-inline-block`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            {moment(obj.AddDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}
                                                        </Box>
                                                        <Box
                                                            className={`d-flex align-item-center justify-content-end`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            <Image
                                                                onClick={() => toggleDetail(index)}
                                                                className={`d-inline-block pointer`}
                                                                src={ChevronDownBlue}
                                                                ms={{
                                                                    width: '8px',
                                                                    height: '8px'
                                                                }} />
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        className={`detail${index} d-none px-xxl`}
                                                        ms={{
                                                            backgroundColor: 'var(--gray-ultra-light)'
                                                        }}>
                                                        <Box
                                                            className={`py-md`}>
                                                            <Box
                                                                className={`d-inline-block`}
                                                                ms={{
                                                                    width: '15%'
                                                                }}>
                                                                ردیف
                                                            </Box>
                                                            <Box
                                                                className={`d-inline-block`}
                                                                ms={{
                                                                    width: '15%'
                                                                }}>
                                                                وضعیت
                                                            </Box>
                                                            <Box
                                                                className={`d-inline-block`}
                                                                ms={{
                                                                    width: '15%'
                                                                }}>
                                                                مبلغ (تومان)
                                                            </Box>
                                                            <Box
                                                                className={`d-inline-block`}
                                                                ms={{
                                                                    width: '15%'
                                                                }}>
                                                                تاریخ
                                                            </Box>
                                                            <Box
                                                                className={`d-inline-block`}
                                                                ms={{
                                                                    width: '15%'
                                                                }}>
                                                                توضیحات
                                                            </Box>
                                                        </Box>
                                                        {obj.Detail.map((childObj, index) => {
                                                            return (
                                                                <Box
                                                                    className={`py-md border-solid-top border-light`}
                                                                    key={index}>
                                                                    <Box
                                                                        className={`d-inline-block`}
                                                                        ms={{
                                                                            width: '15%'
                                                                        }}>
                                                                        {index + 1}
                                                                    </Box>
                                                                    {childObj.Price > 0 &&
                                                                        <Box
                                                                            className={`d-inline-block`}
                                                                            ms={{
                                                                                width: '15%'
                                                                            }}>
                                                                            <Image
                                                                                src={ArrowDownSVG}
                                                                                ms={{
                                                                                    display: 'inline',
                                                                                    width: '16px',
                                                                                    height: '16px'
                                                                                }} />
                                                                            <Typography
                                                                                ms={{
                                                                                    color: 'var(--green-medium)'
                                                                                }}>
                                                                                واریز
                                                                            </Typography>
                                                                        </Box>
                                                                    }
                                                                    {childObj.Price < 0 &&
                                                                        <Box
                                                                            className={`d-inline-block`}
                                                                            ms={{
                                                                                width: '15%'
                                                                            }}>
                                                                            <Image
                                                                                src={ArrowUpSVG}
                                                                                ms={{
                                                                                    display: 'inline',
                                                                                    width: '16px',
                                                                                    height: '16px'
                                                                                }} />
                                                                            <Typography
                                                                                ms={{
                                                                                    color: 'var(--red-medium)'
                                                                                }}>
                                                                                برداشت
                                                                            </Typography>
                                                                        </Box>
                                                                    }
                                                                    <Box
                                                                        className={`d-inline-block`}
                                                                        ms={{
                                                                            width: '15%'
                                                                        }}>
                                                                        {(childObj.Price > 0 ? childObj.Price / 10 : childObj.Price * -1 / 10).toLocaleString()}
                                                                    </Box>
                                                                    <Box
                                                                        className={`d-inline-block`}
                                                                        ms={{
                                                                            width: '15%'
                                                                        }}>
                                                                        {moment(childObj.AddDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}
                                                                    </Box>
                                                                    <Box
                                                                        className={`d-inline-block`}
                                                                        ms={{
                                                                            width: '40%'
                                                                        }}>
                                                                        {childObj.Description}
                                                                    </Box>
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex px-sm rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    color='primary'
                                                    onClick={() => openModal('confirmCreditSettlementModal')}>
                                                    تسویه اعتبار
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Modal
                    className={`increaseWalletModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: 'calc(100% - 12px) !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            افزایش موجودی
                            <Box />
                        </Modal.Header>
                        <Typography
                            className={`px-lg text-justify`}>
                            موجودی کیف پول شما کافی نمی باشد. برای تکمیل فرآیند تسویه اعتبار، کیف پول خود را به مبلغ <Typography
                                component='strong'>{(Math.floor(+insufficientAmount) / 10).toLocaleString()} تومان</Typography> شارژ نمایید.
                        </Typography>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={setCredit}
                                        label='سایر مبالغ (تومان)'
                                        placeholder='سایر مبالغ (تومان)'
                                        hint='حداقل مبلغ 5000 تومان می باشد'
                                        value={(Math.floor(+insufficientAmount) / 10).toLocaleString()} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex`}
                                    size='col-12'>
                                    <Button
                                        onClick={chargeWallet}
                                        variant='filled'
                                        color='primary'>
                                        افزایش موجودی
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('increaseWalletModal')}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Modal.Wrapper>
                </Modal>
                <Modal
                    className={`confirmCreditSettlementModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: 'calc(100% - 12px) !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            تایید تسویه
                            <Box />
                        </Modal.Header>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <Typography>
                                        در صورت تایید مبلغ {(Math.floor(settlementAmount) / 10).toLocaleString()} تومان از موجودی کیف پول شما کسر می گردد.
                                    </Typography>
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex`}
                                    size='col-12'>
                                    <Button
                                        onClick={creditSettlement}
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('confirmCreditSettlementModal')}
                                        variant='outlined'
                                        color='danger'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment>
        );
    }

}

export default List;